import {
  combineReducers,
  createReducer,
  PayloadAction,
} from "@reduxjs/toolkit";
import {
  appUserDataFail,
  appUserDataRequest,
  appUserDataSuccess,
} from "./actions";
import { IAppUser } from "./types";

interface IAppUserInitialState {
  data?: IAppUser;
  isLoading: boolean;
  success: boolean;
  fail: boolean;
}

const APP_USER_INITIAL_STATE: IAppUserInitialState = {
  data: undefined,
  isLoading: false,
  success: false,
  fail: false,
};

const appUserDataReducer = createReducer(APP_USER_INITIAL_STATE, {
  [appUserDataRequest.type]: (state) => ({
    ...state,
    isLoading: true,
    success: false,
    fail: false,
  }),
  [appUserDataSuccess.type]: (state, { payload }: PayloadAction<IAppUser>) => ({
    ...state,
    data: payload,
    isLoading: false,
    success: true,
    fail: false,
  }),
  [appUserDataFail.type]: (state) => ({
    ...state,
    isLoading: false,
    success: false,
    fail: true,
  }),
});

export interface IGeneralState {
  readonly general: IAppUserInitialState;
}

export default combineReducers<IGeneralState>({
  general: appUserDataReducer,
});
